import ArticleIcon from "@mui/icons-material/Article";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

const NoteHitShort = ({ onClick, hit, ...props }) => {
  return (
    <ListItemButton
      key={hit.id}
      onClick={() => onClick && onClick(hit.id, hit)}
      {...props}
    >
      <ListItemIcon variant="small">
        <ArticleIcon />
      </ListItemIcon>
      <ListItemText
        primary={hit.subject || "No name"}
        secondary={hit.content_text || "-"}
        sx={{ width: "70%" }}
      />
      <ListItemText
        secondary={hit["owner_username"]}
        sx={{ maxWidth: "30%", flexGrow: 0, ml: 1 }}
      />
    </ListItemButton>
  );
};

export default NoteHitShort;
